import type {CSSProperties} from 'react';
import {wedgeExactRole as role} from './wedgeRoles.js';

export type WedgeDriveExportLook = 'drive-export-row' | 'drive-export-working' | 'drive-export-connect' | 'drive-export-done';
export const isWedgeDriveExportLook = (look: string | undefined): look is WedgeDriveExportLook => look !== undefined && ['drive-export-row', 'drive-export-working', 'drive-export-connect', 'drive-export-done'].includes(look);

/* These full-width rows keep their released box as the target. Extra targets would overlap the consent note or card edge. */
export function wedgeDriveExportStyle(look: WedgeDriveExportLook): CSSProperties {
  if (look === 'drive-export-done') return {display: 'flex', alignItems: 'center', gap: 12, padding: '13px 14px', textDecoration: 'none', color: 'inherit'};
  if (look === 'drive-export-connect') return {
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: '100%', marginTop: 11, padding: '11px 14px',
    background: role('accent'), color: role('onAccent'), border: 0, borderRadius: 11,
    cursor: 'pointer', fontSize: 13.5, fontWeight: 800, fontFamily: role('font'), opacity: 1,
  };
  return {
    display: 'flex', alignItems: 'center', gap: 12, width: '100%', padding: '13px 14px',
    background: 'none', border: 0, cursor: look === 'drive-export-working' ? 'default' : 'pointer',
    color: 'inherit', textAlign: 'left', opacity: look === 'drive-export-working' ? 0.6 : 1,
  };
}
